import { useEffect } from 'react';

import { FormControl } from '@chakra-ui/react';

import TimeField from 'components/fields/TimeField';

import SharedMessage from '../Message/SharedMessage';

import { useAppDispatch } from 'hooks';

import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

import { SharedTimeInputProps } from './TimeInput.types';

const SharedTimeInput = ({
  label,
  value,
  onChange,
  section,
  formStateKey,
  formActions,
  required,
  message,
  subLabel,
  disabled = false,
}: SharedTimeInputProps) => {
  const dispatch = useAppDispatch();

  const htmlID = subLabel ? `${label} (${subLabel})` : label;
  const isDisabled = useFormBinderDisabled(formStateKey, disabled);

  useEffect(() => {
    if (!required) return;

    if (!value) {
      dispatch(formActions.addMissingMandatoryField({ name: htmlID, section }));
    } else {
      dispatch(formActions.removeMissingMandatoryField(htmlID));
    }
  }, [required, value, htmlID, section, dispatch, formActions]);

  return (
    <FormControl>
      <TimeField
        label={label}
        value={value}
        onChange={onChange}
        required={required}
        htmlID={htmlID}
        isDisabled={isDisabled}
      />

      {message && (
        <SharedMessage
          {...message}
          section={section}
          formStateKey={formStateKey}
          formActions={formActions}
        />
      )}
    </FormControl>
  );
};

export default SharedTimeInput;
